import { Circle } from 'fabric';

export class FabricLayersCircle extends Circle {}

